import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import "./i18n";
import * as serviceWorker from './serviceWorker';
import store from './app/store'
import { httpInterceptor } from './app/helpers/httpInterceptor';
httpInterceptor(store);

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={ store }>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

